import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import { Api } from '../../componentes/Api';
import moment from "moment";



export const CSolicitudPruebasClinicas = ({ data, p, i }) => {
    const [ListadoLineas, SetListadoLineas] = useState([]);
  
    const imprimirRecibo4 = () => {

        const recibo1 = document.getElementById("reciboPago4").innerHTML;
        const ventana = window.open("", "", "width=800,height=800");
        ventana.document.write("<html><head>   <title></title>");
       // ventana.document.write(cssContent);
        ventana.document.write(`<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet"/>
<style>
    @media print {
      .no-print {
            display: none!important;
        }
    }
.imp {
    
  
    background-color: #2f37e3;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top:0px ;
    padding: 4px 6px;
}
  .text-brand { color:#2c7a7b !important; }
  .bg-brand   { background-color:#2c7a7b !important; }
  .border-brand{ border-color:#2c7a7b !important; }

    @media print {
      body * {
        visibility: visible !important;
      }

      .print-button {
        display: none !important;
      }

      @page {
        size: letter;
        margin: 0mm 5mm  0mm 10mm ;
      }
    }
  </style>
  </head><body style="color:#000">    
  <button  class="bg-pink-500 hover:bg-pink-700 text-white font-bold py-2 px-4 rounded  print-button" onClick="window.print()" >
                        Imprimir 
                    </button>      `);
        ventana.document.write(` <div "> 
                          
                        </div>      ${recibo1} 
                            <div class="mt-4 text-center print-button">
                    <button class="bg-pink-500 hover:bg-pink-700 text-white font-bold py-2 px-4 rounded" onClick="window.print()" >
                        Imprimir
                    </button>
                </div>
                        </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        const logoImg1 = ventana.document.getElementById("logoImg1");
        //setTimeout(() => {
        //    ventana.print();
        //}, 2000);
    };
    if (i == 1) {
        setTimeout(() => {
            imprimirRecibo4()
            i = 0
        }, 1000);
       
    }

    return (
        <>
            <div class="max-w-5xl mx-auto p-4 bg-white" id="reciboPago4">
     
                <div class="flex items-center gap-4 mb-4">
                    <div class="w-16">
                        <div class="w-16 h-16 rounded-full bg-brand flex items-center justify-center">
                            <svg class="w-12 h-12 text-white" viewbox="0 0 24 24">
                                <path d="M12,2C6.48,2 2,6.48 2,12s4.48,10 10,10 10-4.48 10-10S17.52,2 12,2z" fill="currentColor"></path>
                            </svg>
                        </div>
                    </div>
                    <div class="flex-1">
                        <h1 class="text-xl font-serif text-brand">{data.descripcion}</h1>
                        <p class="text-sm text-gray-600">{data.tokenWhatsapp}</p>
                        <p class="text-xs text-gray-500">{data.direccion}</p>
                        <p class="text-xs text-gray-500">Tel.: {data.telefono}  • Celular: {data.noWhatsapp}</p>
                        <p class="text-xs text-gray-500">E-mail: {data.email}</p>
                    </div>
                </div>
            
                <h2 class="text-center text-m font-bold text-brand mb-2">
                    FORMULARIO SOLICITUD DE PRUEBAS CLINICAS
                </h2>
              
                <div class="mb">
                    <div class="flex gap-4 mb-2">
                        <div class="flex-1">
                            <label class="block text-gray-900">FECHA: {moment(new Date).format("DD/MM/YYYY")}</label>
                        </div>
                        <div class="flex-1">
                            <label class="block text-gray-900">PACIENTE:{ p}</label>
                        </div>
                    </div>
                </div>
            
                <div class="grid grid-cols-3 gap-8">
                  
                    <div>
                        <section class="mb-1">
                            <h3 class="font-bold text-brand ">HEMATOLOGIA</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Hemograma</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Eritrosedimentación</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">TPT</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Tiempo de Sangría</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Tiempo de Coagulación</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Tiempo de Protrombina</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Investigación de Células LE</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Investig. de Células Falciformes</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Tipificación Sanguínea</label>
                                </div>
                            </div>
                        </section>
                        <section class="mb-1">
                            <h3 class="font-bold text-brand ">ELECTROFORESIS</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Electroforesis de Hemoglobina</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Electroforesis de Proteínas</label>
                                </div>
                            </div>
                        </section>
                        <section class="mb-1">
                            <h3 class="font-bold text-brand ">COPROLOGIA</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Coprocultivo</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Coprológico</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm italic">Digestión en Heces</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm italic">Sustancias Reductoras</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm italic">Investigación de Oxiuros</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Investigación de Ameba</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Investigación de Protozoarios</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Grasas en heces</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Tripsina en heces</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Sangre oculta en heces</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Antígeno de H. Pylori en heces</label>
                                </div>
                            </div>
                        </section>
                        <section class="mb-1">
                            <h3 class="font-bold text-brand ">MARCADORES TUMORALES</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Alfa-Feto Proteínas</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">CA 15-3</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">CA 125</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">CA 19-9</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">CA 72.4</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">CEA</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">PSA Libre y Total</label>
                                </div>
                            </div>
                        </section>
                        <section>
                            <h3 class="font-bold text-gray-700 mb-1">OTROS</h3>
                            <textarea class="border border-gray-400 mt-1 w-full h-24" placeholder="Escriba otras pruebas aquí"></textarea>
                        </section>
                       
                    </div>
                 
                    <div>
                        <section class="mb-1">
                            <h3 class="font-bold text-brand ">MICROBIOLOGIA / INFECCIOSAS</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">HIV</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Western Bloot</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">VDRL</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">FTA-ABS</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Herpes I y II IgM</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Herpes I y II IgG</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Tuberculina</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Rotavirus</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Ameba en Suero AC</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Citomegalovirus IgM</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Citomegalovirus IgG</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Dengue Antígeno</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Toxoplasmosis IgG_IgM</label>
                                </div>
                            </div>
                        </section>
                        <section class="mb-1">
                            <h3 class="font-bold text-brand ">HORMONAS</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Hormona Crecimiento</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Estrógenos Totales</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">FSH</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Insulina</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Progesterona</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Prolactina</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Testosterona</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">TSH</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">T3</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">T4</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">T3 Libre</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">T4 Libre</label>
                                </div>
                            </div>
                        </section>
                        <section class="mb-1">
                            <h3 class="font-bold text-brand ">ORINA</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Uroanálisis Completo</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Depuración de Creatinina</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Urocultivo</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">BUN en Orina de 24 horas</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Proteínas de Bence Jones</label>
                                </div>
                            </div>
                        </section>
                        <section>
                            <h3 class="font-bold text-brand ">INMUNO-SEROLOGIA</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">ANA</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Clamidia IgG___IgM___</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">H. Pylori</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Panel Autoinmune</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Alfa-1 Anti-Tripsina</label>
                                </div>
                            </div>
                        </section>
                    </div>
                  
                    <div>
                        <section class="mb-1">
                            <h3 class="font-bold text-brand ">QUIMICA SANGUINEA</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Glicemia Basal</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Glicemia Post Prandial</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Hemoglobina Glicosilada</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Curva Tolerancia a la glucosa</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Acido Urico</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Colesterol___HDL___LDL</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Triglicéridos</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Urea</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">BUN</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Creatinina</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">TGO___TGP___</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Fosfatasa Alcalina</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Bilirrubina__Directa__Indirecta__Total</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Proteínas Totales y fraccionadas</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">GgTP</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Amilasa</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Lipasa</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Amonio</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Electrolitos Séricos</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Plomo</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Acido Fólico</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Zinc</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Hierro Sérico</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Ferritina</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">TIBC</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">% de Saturación</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Gases Arteriales</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Vitamina B12</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Vitamina D (25OH) Total</label>
                                </div>
                            </div>
                        </section>
                        <section>
                            <h3 class="font-bold text-brand ">MARCADORES HEPATICOS</h3>
                            <div class="space-y">
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Ag. Australiano (HBsAg)</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Anti HBc-IgM</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Anti HBc-IgG</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Anti HBe</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Anti HBs</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">HBe-Ag</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Hepatitis C</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Anti HAV</label>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input class="form-checkbox h-4 w-4 text-pink-600 rounded border-gray-300" type="checkbox" />
                                    <label class="text-sm">Anti HAV IgM</label>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

              
            </div>
        </>
    )
}
